<div [id]="clinicalObj?.title + '-'+clinicalObj?.product_type_id" class="position-relative clinical-res-card">
  <div class="position-absolute b-radius w-100 h-100 prod-masking-div"
    *ngIf="clinicalObj?.channel?.content_visibility?.display==0 || clinicalObj?.channel?.content_visibility?.display==2 || clinicalObj?.hl?.mcnt">
    <app-product-masking-card
      [content_visibility]="clinicalObj?.channel?.content_visibility" [communityVisible]="clinicalObj?.hl?.mcnt"></app-product-masking-card>
  </div>
  <div class="container-shadow" [ngClass]="{'mb-3': callingfrom !== this.mls.googleEventText.grandround.category, 'shadow-none': callingfrom === this.mls.googleEventText.grandround.category}"
    *ngIf="(idx==0 || callingfrom === this.mls.googleEventText.grandround.category) || (callingfrom === callingFrom.EC_DETAIL) || callingfrom === createStoryScreen ">
    <div>
      <div
        *ngIf="!isEditorsChoiceList && callingfrom !== this.mls.googleEventText.grandround.category" [ngClass]="{'d-flex justify-content-between top-radius py-1': !isEditorsChoiceList &&
        clinicalObj?.editor_choice_data?.is_ec_product === numbers.ONE}" [style.background-image]="!isEditorsChoiceList && clinicalObj?.editor_choice_data?.is_ec_product === numbers.ONE &&
        clinicalObj?.editor_choice_data.headers?.color | gradient: gradientDirection.BOTTOM">

        <ng-container *ngIf="!isEditorsChoiceList && clinicalObj?.editor_choice_data?.is_ec_product === numbers.ONE">
          <span class="mr-0 ec-badge  d-flex align-items-center">
            <img class="ec-badge-icon pl-2" src="{{clinicalObj.editor_choice_data.headers?.images.icon | fitInImg :igs.imageGroup.fitin_500x500}}"
              alt="ec badge icon" />
            <span class="ec-text ec-text-overflow" [title]="clinicalObj.editor_choice_data.headers?.highlight_text">
              {{clinicalObj.editor_choice_data.headers?.highlight_text}}
            </span>
          </span>
        </ng-container>
      </div>
      <div (click)="navigateTodetail(clinicalObj?.id)">
        <div class="mb-3 cursor-pointer" id="aricle-card-banner">
          <img  src="{{(clinicalObj?.banner) | fitInImg :igs.imageGroup.fitin_500x500}}"
            onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" alt="placeholder"
            class="w-100  top-radius post-pic-bg img-max-height">
        </div>
        <div class="px-3">
          <div class="row mb-2">
            <div class="col-10 pr-0">
              <p [id]="clinicalObj?.title + '-' + clinicalObj?.id "  class="heading-4 cursor-pointer">{{clinicalObj?.title| slice:0: 130}} {{(clinicalObj?.title.length>130)? '...':''}}</p>
            </div>
            <div class="col-2 cursor-pointer text-right pl-0" id="id-report-three-dot-click">
              <app-ngb-drop-down [ngbDDL]="ngbDDL" [callingfrom]="callingfrom" (click)="fcs.stopEventPropagation()"
                (resetNgbDDLRecord)="resetNgbDDLRecord($event)"></app-ngb-drop-down>
            </div>
          </div>
          <div class="cursor-pointer">
            <p *ngIf="clinicalObj?.categories?.length>0" class="mb-1 secondary-paragraph text-truncate">
              <span *ngFor="let Cl of clinicalObj?.categories;" class="mr-2 color-grey-500"
                (click)="fcs.stopEventPropagation();getSpecialty(Cl)">
                #{{Cl?.category_name}}
              </span>
            </p>
            <div>
              <p class="secondary-paragraph-bold mb-2 mt-2" *ngIf="clinicalObj?.channel !=null">
                <span class="color-grey-700">
                  {{clinicalObj?.institution_name}}</span>
              </p>
              <p class="secondary-paragraph mt-2 mb-3">
                <span class="clicl-pic  pr-2 mr-4 position-relative" *ngIf="clinicalObj?.channel !=null">
                  <img class="mr-2 post-pic-bg rnded-circle" *ngIf="clinicalObj?.channel?.powered_by!=''"
                    src="{{clinicalObj?.channel?.powered_by  | fitInImg :igs.imageGroup.fitin_500x500}}"
                    onerror="this.src='assets/themes/icons/profilepic.svg'" />{{clinicalObj?.channel?.powered_by_label}}
                  {{clinicalObj?.channel?.powered_name}}</span>
                <span class="secondary-paragraph-bold">
                  <span *ngIf="clinicalObj?.channel?.title.length > 0 && clinicalObj?.channel?.title!=null"
                    class="clicl-pic dot color-grey-700 position-relative">
                    <img *ngIf="clinicalObj?.channel?.channel_logo!=''" class="mx-2 post-pic-bg rnded-circle"
                      src="{{clinicalObj?.channel?.channel_logo  | fitInImg :igs.imageGroup.fitin_500x500}}"
                      onerror="this.src='assets/themes/icons/channel-placeholder.svg'" />{{clinicalObj?.channel?.title}}</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="pb-3 pl-3 pr-3 secondary-paragraph">
        <p class="clearfix text">
          <span class="color-grey-500 float-left"
            *ngIf="clinicalObj?.like_count==0">{{mls.languageText.clinical_resource_card.key1}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key1)</span>
          </span>
          <span class="float-left cursor-pointer color-grey-500" id="product-like-list-article-card"
            *ngIf="clinicalObj?.like_count>0" (click)="getProductLikeList()"
            >{{clinicalObj?.like_count}}
            {{clinicalObj?.like_count>1 ? ' '+mls.languageText.clinical_resource_card.key3 : ' '+mls.languageText.clinical_resource_card.key2}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key3,clinical_resource_card.key2)</span>
          </span>
          <span class="float-right new-modal-like-comment color-grey-500" *ngIf="clinicalObj?.total_views>0">
            {{clinicalObj?.total_views}} {{mls.languageText.clinical_resource_card.key12}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key12)</span>
          </span>
        </p>
      </div>
      <div class="img-container brder-top py-3" [ngClass]="isLangEs ? 'secondary-paragraph' : 'paragraph'" *ngIf="callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND">
        <div class="row">
          <div [class]="(this.mls.featureOnOffList.featureList.bookmark.value 
          || this.mls.featureOnOffList.featureList.repost.value 
          || this.mls.featureOnOffList.featureList.share.value ) || !mls.userLoginFlow ? 'pt-1 pb-1 col-3 text-center' : 'pt-1 pb-1 col-12 text-center'" [ngClass]="isLangEs ? 'd-flex justify-content-end px-1' : ''" *ngIf="clinicalObj?.is_activity_allowed==1">
            <span id="product-like-article-card-icon" (click)="productLike();" 
              [ngClass]="{'active color-black' : clinicalObj?.is_liked == true}" class="cursor-pointer text-truncate alignment">
              <img src="assets/themes/images/primary-loader.gif"
                width="25" id="id-bookmar-card-article"
                *ngIf="feed_like_loader==true"
                alt="loader"/>

              <span class="pr-md-2" *ngIf="clinicalObj?.is_liked != true && feed_like_loader==false">
                <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" src="assets/themes/icons/like-white.svg" alt="like" /></span>

              <span class="pr-md-2" *ngIf="clinicalObj?.is_liked == true && feed_like_loader==false">
                <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" src="assets/themes/icons/like-black.svg" alt="liked" /></span>

              <span *ngIf="clinicalObj?.is_liked != true"
                class="color-grey-700">{{mls.languageText.clinical_resource_card.key2}}
                <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key2)</span>
              </span>
                <span *ngIf="clinicalObj?.is_liked == true" class="color-black">
                 {{mls.languageText.clinical_resource_card.key4}}
                 <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key34)</span>
                </span>
            </span>
          </div>

          <div class="col-3 text-center pt-1 pb-1 pl-0 pr-0"
            *ngIf="clinicalObj?.is_activity_allowed==1 && (this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow)">
            <span [ngClass]="{'active color-black': clinicalObj.is_bookmarked==true}" id="article-card-bookmark"
              (click)="fcs.stopEventPropagation(); productBookmark()" class="cursor-pointer text-truncate alignment"
              id="aricle-card-bookemark"
             >

              <img src="assets/themes/images/primary-loader.gif"
                width="25"
                *ngIf="feed_bookmark_loader==true"
                alt="loader"/>

              <span class="pr-md-2" *ngIf="clinicalObj.is_bookmarked!=true && feed_bookmark_loader==false">
                <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" src="assets/themes/icons/bookmark-white.svg" alt="bookmark" />
              </span>
              <span class="pr-md-2" *ngIf="clinicalObj.is_bookmarked==true && feed_bookmark_loader==false">
                <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" src="assets/themes/icons/bookmark-black.svg" alt="bookmarked" />
              </span>
              <span *ngIf="clinicalObj?.is_bookmarked != true">
                <span class="color-grey-700">{{mls.languageText.clinical_resource_card.key5}}</span>
                 <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key5)</span>
              </span>
                <span *ngIf="clinicalObj?.is_bookmarked == true">
                  <span class="color-black">{{mls.languageText.clinical_resource_card.key6}}</span>
                  <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key6)</span>
                </span>
            </span>
          </div>

          <div *ngIf="this.mls.featureOnOffList.featureList.repost.value || !mls.userLoginFlow" class="col-3 text-center pt-1 pb-1" [ngClass]="isLangEs ? 'px-md-0' : 'px-0'">
            <p id="repost-article-card">
              <app-repost-popover *ngIf="showRepostPopOver"
                [isInfoModalShown]="true"
                (emitStartRequest)="closeRepostTooltip()"
                (emitHideModal)="closeRepostTooltip()"
                [screenName]="screenName">
              </app-repost-popover>
              <span  (click)="$event.stopPropagation();generateMeta()"class="cursor-pointer button">
                <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" class="mr-2" src="assets/themes/icons/repost.svg" alt="icon-repost">
                <span class="color-grey-700">{{mls.languageText.webinar_card.key12}}</span>
                <app-repost-type-list-meta *ngIf="isMetaGenerated"
                   [productId]="docCardObj?.product_type_id"
                   (closeToolTip)="closeMeta($event)"
                   [callingFrom]="'CLINICAL_RESOURCE'"
                   (emitRepostType)="repostArticleType($event)">
                </app-repost-type-list-meta>
              </span>
            </p>
          </div>

          <div *ngIf="clinicalObj?.is_activity_allowed==1 && (this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow)" class="float-right col-3 text-center pb-1 pt-1" [ngClass]="isLangEs ? 'd-flex justify-content-start px-1' : ''">
            <span (click)="productShare()" id="article-card-share-click"
              class="cursor-pointer mr-1 text-truncate alignment">
              <img [ngClass]="isLangEs ? 'img-twenty' : 'img-twenty-four'" src="assets/themes/icons/share.svg" alt="share" />
                <span class="pl-md-2 color-grey-700">{{mls.languageText.clinical_resource_card.key7}}</span>
                <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key7)</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  -->
  <div  [Id]="clinicalObj?.title + '-'+clinicalObj?.product_type_id"  class="mb-3 container-shadow"
    *ngIf="(idx>0 && callingfrom !== this.mls.googleEventText.grandround.category) &&  (callingfrom !== callingFrom.EC_DETAIL)">
    <div class="p-2 top-radius"
      *ngIf="!isEditorsChoiceList && clinicalObj?.editor_choice_data.is_ec_product === numbers.ONE" [ngClass]="{'d-flex justify-content-between':
        clinicalObj?.editor_choice_data.is_ec_product === numbers.ONE}" [style.background-image]="clinicalObj?.editor_choice_data.is_ec_product === numbers.ONE &&
        clinicalObj?.editor_choice_data.headers?.color | gradient: gradientDirection.BOTTOM">
      <p class="mr-2">
      </p>
      <ng-container  *ngIf="clinicalObj?.editor_choice_data.is_ec_product === numbers.ONE">
        <span class="mr-0 ec-badge d-flex align-items-center">
          <img class="ec-badge-icon" src="{{clinicalObj.editor_choice_data.headers?.images.icon 
          | fitInImg :igs.imageGroup.fitin_500x500}}"
            alt="ec badge icon" />
          <span class="ec-text ec-text-overflow" [title]="clinicalObj.editor_choice_data.headers?.highlight_text">
            {{clinicalObj.editor_choice_data.headers?.highlight_text}}
          </span>
        </span>
      </ng-container>
    </div>
    <div class="px-3 py-3">
    <div class="row">
      <div (click)="navigateTodetail(clinicalObj?.id)"
        class="col-8 pr-0 secondary-paragraph cursor-pointer">
        <p  [id]="'title-' + clinicalObj?.title + '-' + clinicalObj?.id " class="mb-2 heading-4">{{clinicalObj?.title| slice:0: 130}} {{(clinicalObj?.title.length>130)? '...':''}}</p>

        <p class="mb-2 secondary-paragraph text-truncate">
          <span (click)="getSpecialty(Cl)" class="mr-2 color-grey-500" *ngFor="let Cl of clinicalObj?.categories;">
            <span *ngIf="clinicalObj?.categories !=''">#</span>{{Cl?.category_name}}
          </span>
        </p>
        <p class="mb-3 secondary-paragraph-bold"><span class="color-grey-700">{{clinicalObj?.institution_name}}</span></p>
      </div>
      <div (click)="navigateTodetail(clinicalObj?.id)" id="aricle-banner-list-card"
        
        class="col-4 cursor-pointer text-right">
        <div class="position-relative"><img class="img-b-radius" src="{{clinicalObj?.banner | fitInImg :igs.imageGroup.fitin_500x500}}"
            onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-12 pr-0 pl-0 calc-51">
        <p (click)="navigateTodetail(clinicalObj?.id)" class="secondary-paragraph mt-2 cursor-pointer">
          <span class="clicl-pic mr-4 position-relative d-inline-block responsive-padding" *ngIf="clinicalObj?.channel !=null">
            <img class="mr-2 post-pic-bg rnded-circle" src="{{clinicalObj?.channel?.powered_by | fitInImg :igs.imageGroup.fitin_500x500}}"
              onerror="this.src='assets/themes/icons/profilepic.svg'" />{{clinicalObj?.channel?.powered_by_label}}
            {{clinicalObj?.channel?.powered_name}}</span>
          <span class="secondary-paragraph-bold">
            <span *ngIf="clinicalObj?.channel?.title?.length > 0"
              class="clicl-pic dot color-grey-700 position-relative">
              <img class="mr-2 post-pic-bg rnded-circle" src="{{clinicalObj?.channel?.channel_logo | fitInImg :igs.imageGroup.fitin_500x500}}"
                onerror="this.src='assets/themes/icons/channel-placeholder.svg'" />{{clinicalObj?.channel?.title}}</span>
          </span>
        </p>
      </div>

      <div class="col-2 d-flex cursor-pointer mt-2 text-right bookmrk-sm-crd pl-0 pr-0"
        *ngIf="clinicalObj?.is_activity_allowed==1 && (this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow)">
        <span [ngClass]="{'active color-black': clinicalObj.is_bookmarked==true}" (click)="productBookmark()" id="article-card-bookmark"
          class="cursor-pointer secondary-paragraph"
          *ngIf="callingfrom != this.mls.googleEventText.grandround.category"
          >
          <img src="assets/themes/images/primary-loader.gif"
                width="25"
                *ngIf="feed_bookmark_loader==true"
                alt="loader"/>
          <span  *ngIf="clinicalObj.is_bookmarked!=true && feed_bookmark_loader==false">
            <img class="mr-2 mt-1" width="16px"  src="assets/themes/icons/bookmark-white.svg" alt="bookmark" /></span>

          <span *ngIf="clinicalObj.is_bookmarked==true && feed_bookmark_loader==false">
            <img class="mr-2 mt-1" width="16px"  src="assets/themes/icons/bookmark-black.svg" alt="bookmark" /></span>
        </span>
        <app-ngb-drop-down [ngbDDL]="ngbDDL" (resetNgbDDLRecord)="resetNgbDDLRecord($event)" [callingfrom]="callingfrom"></app-ngb-drop-down>
      </div>
    </div>
    <!-- grandround -->
    <div *ngIf="callingfrom === this.mls.googleEventText.grandround.category">
      <div
        class="mt-2 border-top border-bottm pt-1 pb-1 pl-2 pr-2 secondary-paragraph color-grey-500">
        <p class="clearfix">
          <span class="new-modal-like-comment float-left"
            *ngIf="clinicalObj?.like_count==0">{{mls.languageText.clinical_resource_card.key1}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key1)</span>
          </span>
          <span class=" float-left cursor-pointer " *ngIf="clinicalObj?.like_count>0"
            (click)="getProductLikeList()" id="product-like-list-card"
            >{{clinicalObj?.like_count}}
            {{clinicalObj?.like_count>1 ? ' '+mls.languageText.clinical_resource_card.key3 : ' '+mls.languageText.clinical_resource_card.key2}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key2,clinical_resource_card.key3)</span>
          </span>
          <span class="float-right new-modal-like-comment">{{clinicalObj?.total_views}}
            {{mls.languageText.clinical_resource_card.key12}}
            <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key12)</span>
          </span>
        </p>
      </div>
      <div class="secondary-paragraph color-grey-500">
        <div class="row">
          <div class="col-4 text-center pt-2" *ngIf="clinicalObj?.is_activity_allowed==1">
            <span (click)="productLike();" [ngClass]="{'active color-black' : clinicalObj?.is_liked == true}" id="product-like-icon-click"
              class="cursor-pointer"
              >
              <img src="assets/themes/images/primary-loader.gif"
                width="25"
                *ngIf="feed_like_loader==true"
                alt="loader"/>

              <span *ngIf="clinicalObj?.is_liked != true && feed_like_loader==false">
                <img width="24px" height="24px" src="assets/themes/icons/like-white.svg" alt="like" /></span>

              <span *ngIf="clinicalObj?.is_liked == true && feed_like_loader==false">
                <img width="24px" height="24px" src="assets/themes/icons/like-black.svg" alt="liked" /></span>

              <span *ngIf="clinicalObj?.is_liked != true">{{mls.languageText.clinical_resource_card.key2}}
                <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key2)</span>
              </span>
                  <span *ngIf="clinicalObj?.is_liked == true">{{mls.languageText.clinical_resource_card.key4}}
                    <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key4)</span>
                  </span>
            </span>
          </div>

          <div class="col-4 text-center pt-2" *ngIf="clinicalObj?.is_activity_allowed==1">
            <span [ngClass]="{'active color-black': clinicalObj.is_bookmarked==true}" (click)="productBookmark()" id="article-card-bookmark"
              class="cursor-pointer" id="article-product-bookmark">
              <img src="assets/themes/images/primary-loader.gif"
                width="25"
                *ngIf="feed_bookmark_loader==true"
                alt="loader"/>
              <span *ngIf="clinicalObj.is_bookmarked!=true && feed_bookmark_loader==false">
                <img width="24px" height="24px" src="assets/themes/icons/bookmark-white.svg" alt="bookmark" /></span>

              <span *ngIf="clinicalObj.is_bookmarked==true && feed_bookmark_loader==false">
                <img width="24px" height="24px" src="assets/themes/icons/bookmark-black.svg" alt="bookmark" /></span>
              <span *ngIf="clinicalObj?.is_bookmarked != true">{{mls.languageText.clinical_resource_card.key5}}
                <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key5)</span>
              </span>
                <span *ngIf="clinicalObj?.is_bookmarked == true">{{mls.languageText.clinical_resource_card.key6}}
                  <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key6)</span>
                </span>
            </span>
          </div>

          <div *ngIf="clinicalObj?.is_activity_allowed==1" class="float-right col-4 text-center pt-2">
            <div (click)="productShare()" class="cursor-pointer" id="aricle-share-click-card">
              <img width="24px" height="24px" src="assets/themes/icons/share.svg" alt="share"/>
              {{mls.languageText.clinical_resource_card.key7}}
              <span *ngIf="mls?.is_lskey_display==1">(clinical_resource_card.key7)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<!-- like list popup start**************************** -->
<app-product-like *ngIf="showLikeListModal" (resetLikeModalList)=resetLikeModalList($event)
  (resetLike)=resetLike($event) [likeObj]=likeObj></app-product-like>
<!-- like list popup end ***************************** -->

<app-product-subscribe *ngIf="showSubscribeModal" [showSubscribeModal]=showSubscribeModal [channelData]="subscribe_obj"
  (resetSubscribeModal)="resetSubscribeModal()"></app-product-subscribe>
  <div *ngIf="callingfrom !== 'BOOKMARK_LIST' && callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen" class="position-relative  clinical-res-card">
    
    <div class="position-absolute b-radius w-100 h-100 prod-masking-div"
      *ngIf="clinicalObj?.channel?.content_visibility?.display==0 || clinicalObj?.channel?.content_visibility?.display==2">
      <app-product-masking-card
        [content_visibility]="">
      </app-product-masking-card>
    </div>

    <div class="mt-2" *ngIf="clinicalObj?.comment_flag !== numbers.ZERO ">
        <app-product-comment
            [callingFrom]="callingfrom"
            [comment_box_obj]="comment_box_obj" 
            *ngIf="clinicalObj?.comment_flag === numbers.ONE"
            [commentObj]="commentObj"
            [showCommentBox]="numbers.ZERO"
            [screen_name]="screen_name"
            [is_activity]="is_activity"
            [list_type]="commentListType.TOP">
        </app-product-comment>
    </div>
    <div class="pt-3 px-3 separator-line separator-line " *ngIf="callingfrom === screen.GRAND_ROUND &&  clinicalObj?.comment_flag!='0' ">
      <app-product-comment-box
          [callingFrom]="callingfrom"
          [comment_box_obj]="comment_box_obj"
          (resetComment)="resetComment($event)"
          [emitUserComment]="emitUserComment">
      </app-product-comment-box>
  </div>
</div>
